<template lang="pug">
.fill-height
  iframe(name='iframe_q' style='display:none;')
  //- ANCHOR right sidebar
  v-navigation-drawer(app right disable-route-watcher :width='idx_bar_width' v-model='show_sidebar')
    v-container(style='align-content: start;')
      v-row(align='start' v-if='jj')
        v-col
          span.ma-1(v-text='jj.journal_name')
      v-row
        v-col
          v-skeleton-loader(:loading='loading_indexes' type='table')
            v-btn-toggle(color='deep-purple accent-3' mandatory tile group)
              v-btn(exact :to="{name: 'JournalHome', params: { uniname } }")
                v-icon mdi-home
              template(v-for="(i, n) in indexes_used")
                v-btn(
                  :key='`index_btn_${n}`'
                  :to="{name: 'JournalIdx', params: {uniname, idx: i.key}}"
                ) {{$abbr(i.key)}}
            v-divider
            template(v-if="safe_idx == 'home'")
              //- cover模式的home，使用年份做為索引
              template(v-if='cover_support_')
                v-row.ma-1
                  v-btn-toggle(dense mandatory group)
                    v-btn(icon @click='toggle_sort(vols)')
                      v-icon(v-if='vols.sort_descending') mdi-sort-descending
                      v-icon(v-else) mdi-sort-ascending
                  v-spacer
                  v-btn-toggle(dense mandatory group v-model='vols_per_line')
                    v-tip-icon-btn(mdi='numeric-4-box-multiple-outline' :tip="$t('4rows')" :value='4')
                    v-tip-icon-btn(mdi='numeric-3-box-multiple-outline' :tip="$t('3rows')" :value='3')
                  v-spacer
                v-row
                  v-col.pa-0
                    v-skeleton-loader(v-model='loading_vols')
                      v-subheader
                        v-btn(icon @click='toggle_show_level(vols)')
                          v-icon(v-if='next_show_level(vols)==0') mdi-minus-circle-outline
                          v-icon(v-else-if='next_show_level(vols)==1') mdi-dots-horizontal
                          v-icon(v-else-if='next_show_level(vols)==2') mdi-plus-circle-outline
                        span {{$t('pubyear')}}
                      v-list(dense)
                        v-list-item(v-for='v in vols_nav' :key="'volno_nav_' + String(v.metano)" @click="on_goto_cover(v)")
                          v-list-item-content
                            v-list-item-title {{$u.pubtime_str(v.pubyear)}}
              //- 非封面模式，在側欄列出索引類型
              template(v-else)
                v-row
                  v-col
                    v-list(dense)
                      v-list-item(v-if='indexes_used.length == 0' :to="{name: 'JournalIdx', params: {uniname, idx: 'all'}}")
                        v-list-item-content
                          v-list-item-title &#x5168;&#x90E8;({{raw_artis.length}})
                      v-list-item(v-else v-for='(i, n) in indexes_used' :key='`idx_meta_${n}`' :to="{name: 'JournalIdx', params: {uniname, idx: i.key}}")
                        v-list-item-content
                          //- span {{i}}
                          v-list-item-title {{$t(i.key)}}({{i.items.length}})
            //- home 以外的其他索引
            template(v-else)
              v-row.ma-1
                v-col
                  //- 一般 index 文字篩選
                  template(v-if='idx_ && idx_.support_filter')
                    //- span {{i}}
                    v-text-field(clearable dense autocomplete :name='`${idx_.key}_filter_str`' :hint='`篩選${idx_.name}清單`' v-model='idx_.filter_str')
                    v-spacer
                  //- 一般 index 正/反向排序
                  v-btn-toggle(v-show='idx_&& idx_.sort_descending !== undefined' dense group mandatory)
                    v-btn(icon @click='toggle_sort(idx_)')
                      v-icon(v-if='idx_.sort_descending') mdi-sort-descending
                      v-icon(v-else) mdi-sort-ascending
              v-row
                v-col.pa-0
                  v-card.ma-1
                    v-subheader
                      template(v-if='idx_ && idx_.show_levels !== false')
                        v-btn(icon @click='toggle_show_level(idx_)')
                          v-icon(v-if='next_show_level(idx_)==0') mdi-minus-circle-outline
                          v-icon(v-else-if='next_show_level(idx_)==1') mdi-dots-horizontal
                          v-icon(v-else-if='next_show_level(idx_)==2') mdi-plus-circle-outline
                      span(v-text='`${$t(idx_.key)}：(${items_by_show_level(idx_).length})`')
                    v-list(dense)
                      v-virtual-scroll(:items='items_by_show_level(idx_)' :item-height='44' :height='index_vscroll_height')
                        template(v-slot='{ item }')
                          v-list-item(:to="{name: 'JournalIdx', params: {uniname, idx, ikey: item.key}}")
                            v-list-item-content
                              v-list-item-title(v-if="idx=='pubtime'") {{ $u.pubtime_str(item.key) }}
                              v-list-item-title(v-else) {{ item.key }}
                              v-list-item-subtitle {{ $tc('articles_str', item.doc_count) }}
  //- ANCHOR content area 文章列表
  v-container(style='max-width: 1200px; min-width: 60px; align-content: start; justify-content: center;')
    //- home index
    template(v-if="(idx == 'home')")
      v-row(v-if='jj')
        v-col
          search-bar(:uniname='uniname')
      //- v-row(v-if='uniname == mainset_id')
        v-col
          set-info(:setsn="mainset_id")
      v-row(v-if='jj')
        v-col
          j-info(:jj='jj' :no-hover='!cover_support_')
      //- 封面模式，只支援出版年月建立的 vols
      v-row(v-if='vols.items && cover_support_')
        v-col
          v-subheader {{$t(&apos;volno&apos;)}}({{vols.items.length}})
          v-row
            v-col(v-for='(i, n) in vols.items' :key="'vol_' + String(n)" :id='`cover_${i.metano}`' :cols='12' :md='12/vols_per_line' :sm='12/3')
              v-lazy(:id='`cover_${i.metano}`' min-width='120' max-width='276' min-height='190' max-height='435')
                v-hover(v-slot:default='{ hover }')
                  v-card(hover :elevation='hover ? 12 : 2' :to="{name: 'JournalIdx', params: {uniname, idx:'pubtime', ikey: i.pubtime}}")
                    v-img.grey.lighten-2(:src='vol_cover(i)' :aspect-ratio='21/29' :alt='vol_meta(i)')
                      template(v-slot:placeholder="")
                        v-row.fill-height.ma-0(align='center' justify='center')
                          v-progress-circular(indeterminate color='grey')
                    v-card-subtitle {{vol_meta(i)}}
      v-row(v-else)
        v-col
          v-list(dense)
            v-list-item(v-if='indexes_used.length == 0' :to="{name: 'JournalIdx', params: {uniname, idx: 'all'}}")
              v-list-item-content
                v-list-item-title &#x5168;&#x90E8;({{raw_artis.length}})
            v-list-item(v-else v-for='(i, n) in indexes_used' :key='`idx_meta_${n}`' :to="{name: 'JournalIdx', params: {uniname, idx: i.key}}")
              v-list-item-content
                v-list-item-title {{$t(i.key)}}({{i.items.length}})
    //- non Home index，依index顯示filtered artis
    template(v-else)
      template(v-if="filtered_artis && filtered_artis.length > 0")
        //- span aaa::{{ filtered_artis }}
        v-row
          v-col
            v-subheader(v-if='filtered_desc' ref='artis_vlist_top') {{filtered_desc}}
        v-row.fill-height(justify='center')
          v-col.fill-height
            span(ref='artis_vlist_top')
            //- filtered artis，dic/dit/dif/lio/lip 實作
            //- 圖文masonry模式
            masonry-artis(v-if='dic_mode' progressive :items='filtered_artis')
            //- filtered artis，預設以 virtual scroll 實作
            lazy-artis(v-else :artis='filtered_artis' :item-height='65')
      template(v-else)
        v-row
          v-col(align="center")
            //- span bbb::{{ filtered_artis }}
            v-card.ma-1(max-width="600" align="start")
              v-subheader
                template(v-if='idx_ && idx_.show_levels !== false')
                  v-btn(icon @click='toggle_show_level(idx_)')
                    v-icon(v-if='next_show_level(idx_)==0') mdi-minus-circle-outline
                    v-icon(v-else-if='next_show_level(idx_)==1') mdi-dots-horizontal
                    v-icon(v-else-if='next_show_level(idx_)==2') mdi-plus-circle-outline
                span(v-text='`${$t(idx_.key)}：(${items_by_show_level(idx_).length})`')
              v-list(dense)
                v-virtual-scroll(:items='items_by_show_level(idx_)' :item-height='44' :height='index_vscroll_height')
                  template(v-slot='{ item }')
                    v-list-item(:to="{name: 'JournalIdx', params: {uniname, idx, ikey: item.key}}")
                      v-list-item-content
                        v-list-item-title(v-if="idx=='pubtime'") {{ $u.pubtime_str(item.key) }}
                        v-list-item-title(v-else) {{ item.key }}
                        v-list-item-subtitle {{ $tc('articles_str', item.doc_count) }}
</template>
<script>
import {debug} from 'loglevel'
import { ref, computed, watch, toRefs } from '@vue/composition-api'
const assert = console.assert
import _ from "lodash"
import {
  get_journal,
  get_journal_vols,
  get_indexed_artis,
} from "@/api";
import {onDownloadComplete, onDownloadProgress} from "@/api/sys_notify"
// import router from "@/router"
import CollectionInfo from "@/components/ColInfo"
import JInfo from "@/components/JInfo"
// import JArtis from "@/components/JArtis"
import MoreItems from "@/components/MoreItems"
import LazyArtis from "@/components/LazyArtis"
import VTipIconBtn from "@/components/VTipIconBtn"
import MasonryArtis from "@/components/MasonryArtis"
import SearchBar from "@/components/SearchBar"
import SetInfo from "@/components/SetInfo"

function build_vols_nav(vols, show_less) {
  var nav = []
  var last_pubyear = null
  vols.forEach(i=>{
    if(last_pubyear != i.pubyear) {
      last_pubyear = i.pubyear
      nav.push(i)
    }
  })
  if(!show_less || nav.length <= 20) {
    return nav
  }

  const step = nav.length / 20
  var nav2 = [], pos = 0
  for(var i = 0; i < 20; i += 1) {
    nav2.push(nav[_.round(pos)])
    pos += step
  }
  return nav2
}

export default {
  name: 'JournalView',
  components: {
    CollectionInfo,
    JInfo,
    MoreItems,
    LazyArtis,
    VTipIconBtn,
    MasonryArtis,
    SearchBar,
    SetInfo,
  },
  props: {
    uniname: {},
    cover_support: { default: null },
    idx: { default: "home" },
    ikey: { default: null },
    imetano: { default: null },
    preloaded_artis: {},
  },
  setup(props) {
    // debug('setup...')
    // const {uniname, cover_support, idx, ikey, imetano} = toRefs(props)
    const {uniname, cover_support, ikey} = toRefs(props)
    const jj = ref({})
    get_journal(uniname.value).then((resp) => {
      jj.value = resp
    })
    const dic_mode = computed(()=>{
      return ['dic', 'dif', 'dit', 'lip', 'lio', 'wai', 'diw', 'pmb', 'pmm', 'pmr', 'pmq'].includes(uniname.value)
    })
    const cover_support_ = computed(() => {
      if(cover_support.value !== undefined) {
        cover_support.value
      }
      const supp = ['bio', 'lio', 'mdn', 'pmb', 'pmm', 'pmr', 'pmq', 'wxm', 'nyr', 'ctm']
      if(supp.includes(uniname.value) || jj.value.cover_mode) {
        return true
      }
      else {
        return false
      }
    })
    return {
      jj,
      dic_mode, cover_support_,
    }
  },
  computed: {
    filtered_artis_with_max() {
      return this.filtered_artis.slice(0, this.filtered_artis_display_max)
    },
    safe_idx() {
      const mm = this.indexes_used
      const idx = this.idx
      for(let i = 0; i < mm.length; i++) {
        if(mm[i].key == idx) return idx
      }
      return 'home'
    },
    idx_() {
      return this.indexes_[this.safe_idx]
    },
    indexes_used() {
      if(this.loading_indexes) {
        return {}
      }
      var mm = []
      debug('keys', typeof(this.indexes_), this.indexes_)
      var keys = ['word', 'pubyear', 'pubtime', 'volno', 'authors', 'title', 'sourcesdes', 'dynasty']
      debug('this.mainset_id', this.mainset_id)
      if(this.mainset_id == 'cbs') {
        keys = ['branch']
        mm.push(this.indexes_.all)
        debug('mm-cbs', mm)
      }
      else if(this.cover_support_) {
        // pubyear 會在home頁，所以從其他索引中移除
        keys = ['pubtime', 'volno', 'authors', 'title', 'dynasty']
      }
      // 檢查是否存在至少一個用來依序看所有文章的方法
      var full_listed = false
      keys.forEach((k)=>{
        if(this.indexes_[k].items.length > 1) {
          mm.push(this.indexes_[k])
          if(['all', 'pubyear', 'pubtime'].includes(k)) {
            full_listed = true
          }
        }
      })
      if(!full_listed) {
        // 目前是發生在dit dic dif，但是全部項目太多，masonry render極卡
        // 即使使用v-lazy技巧也極卡
        // 目前觀察使用v-lazy技巧似乎和masonry相容性不好
        // mm.unshift(this.indexes_.all)
      }
      debug('mm', mm)
      return mm
    },
    idx_bar_width() {
      const min = 5 * 64 + 32
      if(this.loading_indexes) {
        return min
      }
      const w = (this.indexes_used.length + 1) * 64 + 32
      return w > min ? w : min
    },
    vols_nav() {
      assert(this.vols)
      if(this.vols.show_level == 0) {
        return []
      }
      else {
        return build_vols_nav(this.vols.items, Boolean(this.vols.show_level == 1))
      }
    },
  },
  methods: {
    on_goto_cover(v) {
      // TODO: 找尋讓v-lazy可以確認提供pos(for goTo)的方法
      this.$vuetify.goTo('#cover_' + v.metano)
    },
    arti_meta(i) {
      var mm = []
      const uniname = i.metano.slice(0, 3)
      if(['dit', 'dic', 'dif'].includes(uniname)) return ''
      if(i.pubtime) {
        mm.push(this.$u.pubtime_str(i.pubtime))
      }
      if(i.volno && !['wai'].includes(uniname)) {
        mm.push(i.volno)
      }
      if(i.authors) {
        mm.push(i.authors)
      }
      // if(i.word) {
      //   mm.push(i.word)
      // }
      if(i.sourcesdes) {
        mm.push(i.sourcesdes)
      }
      if(i.dynasty) {
        mm.push(i.dynasty)
      }
      if(i.pages) {
        mm.push(`${i.pages}頁`)
      }
      const s = mm.join('／')
      return s
    },
    arti_images(i) {
      // debug('i', i)
      const uniname = i.metano.slice(0, 3)
      var rr = []
      if(Array.isArray(i.images)) {
        i.images.forEach((j)=>{
          const src = this.$u.fix_image_src(uniname, j.src, {small:true})
          const alt = j.alt
          rr.push({src, alt})
        })
      }
      // debug('rr', rr)
      if(['lio', 'lip', 'wai', 'diw'].includes(this.uniname)) {
        return rr.slice(0, 1)
      }
      return rr
    },
    // redraw_masonry() {
    //   const that = this
    //   if(that.$masonry_redraw) {
    //     clearTimeout(that.$masonry_redraw)
    //   }
    //   that.$masonry_redraw = setTimeout(()=>{
    //     that.$redrawVueMasonry()
    //     delete that.$masonry_redraw
    //   }, 200)
    // },
    toggle_sort(idx_) {
      idx_.sort_descending = !idx_.sort_descending
      idx_.items = idx_.items.reverse()
    },
    set_sort(idx_, sort_descending) {
      if(idx_.sort_descending == sort_descending) return
      return this.toggle_sort(idx_)
    },
    next_show_level(idx_) {
      assert(idx_)
      const show_levels = idx_.show_levels ? idx_.show_levels : {2:0, 0:2} 
      return show_levels[idx_.show_level]
    },
    toggle_show_level(idx_) {
      assert(idx_)
      idx_.show_level = this.next_show_level(idx_)
    },
    items_by_show_level(idx_) {
      assert(idx_)
      var items_ = idx_.items
      if(idx_.show_level == 0) {
        return []
      }
      if(idx_.show_level == 1) {
        items_ = items_.filter(i=>Boolean(i.doc_count > 1))
      }
      if(idx_.support_filter && idx_.filter_str) {
        items_ = items_.filter(i=>Boolean(i.key.includes(idx_.filter_str)))
      }
      return items_
    },
    vol_cover(i) {
      if(this.uniname == 'lio') {
        const url = `/images/${this.uniname}/cover/${_.padStart(String(i.volno2+1), 4, '0')}.jpg`
        return url
      }
      else {
        const url = `/images/${this.uniname}/cover/${_.padStart(String(i.volno2), 4, '0')}.jpg`
        return url
      }
    },
    vol_meta(i) {
      var mm = []
      mm.push(this.$u.pubtime_str(i.pubtime))
      // mm.push('第' + String(i.volno2) + '期')
      mm.push(String(i.volno))
      var s = mm.join(' / ')
      return s
    },
    arti_subtitle(i) {
      var mm = []
      if(i.column) {
        mm.push(i.column)
      }
      else if(i.metano.slice(0, 3) == 'lio' && i.keyword) {
        // TODO 資料修正後應移除此 workaround
        mm.push(i.keyword)
      }
      const s = mm.join(' / ')
      return s
    },
    focus_on_item(idx, item) {
      return this.focus_on_key(idx, item.key)
    },
    focus_on_key(idx, key) {
      debug('on_key', idx, key)
      if(this.raw_artis == undefined) {
        return Promise.resolve()
      }
      // const cache_key = `${idx}-${key}`
      // var cache = require('js-cache');
      const that = this
      return new Promise((resolve)=>{
        // const t0 = performance.now()
        that.filtered_artis = []
        if(idx == 'all') {
          that.filtered_artis = that.raw_artis
          that.filtered_desc = undefined
        }
        else if(idx == 'branch') {
          const filtered_artis = that.raw_artis.filter((i) => i.title && i.title.split('#')[1] == key)
          that.filtered_artis = filtered_artis
          that.filtered_desc = `${that.indexes_[idx].name} - ${key}`
        }
        else if(idx == 'title') {
          const filtered_artis = that.raw_artis.filter((i) => i.title && i.title.slice(0, 1) == key)
          that.filtered_artis = filtered_artis
          that.filtered_desc = `${that.indexes_[idx].name} - ${key}`
        }
        // else if(idx == 'pubtime') {
        //   const filtered_artis = that.raw_artis.filter((i) => i[idx] == key)
        //   that.filtered_artis = filtered_artis
        //   that.filtered_desc = `${that.indexes_[idx].name} - ${that.$u.pubtime_str(key)}`
        // }
        else {
          const filtered_artis = that.raw_artis.filter((i) => i[idx] == key)
          that.filtered_artis = filtered_artis
          that.filtered_desc = `${that.indexes_[idx].name} - ${key}`
        }
        resolve()
      })
    },
    on_uniname(uniname) {
      // debug('on_uniname', uniname)
      var wait_all = []

      this.loading_indexes = true
      for(var k in this.indexes) {
        this.indexes[k] = []
      }
      this.filters = []
      this.filtered_artis = []
      this.filtered_artis_display_max = 200
      this.artis_subtitle = null
      this.raw_artis = []

      const opt = {onDownloadProgress, onDownloadComplete}
      const load_indexed_artis = function(resp) {
        if(['wai', 'diw'].includes(uniname)) {
          // const fixWordGif2 = (ii, k) => { if(ii[k]) ii[k] = ii[k].replaceAll('[wgif]', '<img src="/images/wordgif/').replaceAll('[/wgif', '" border="0" />') }
          const fixWordGif = (ii, k) => { if(ii[k]) ii[k] = ii[k].replace(/\[wgif\]/g, '<img src="/images/wordgif/').replace(/\/wgif/g, '" border="0" />') }
          for(let i in resp.artis) {
            const ii = resp.artis[i]
            fixWordGif(ii, 'title')
            fixWordGif(ii, 'content')
          }
        }
        vm.raw_artis = resp.artis
        vm.indexes_.all.items[0].doc_count = vm.raw_artis.length
        const aggs = resp.aggs
        for(var k in vm.indexes_) {
          if(aggs[k]) {
            const items = vm.indexes_[k].sort_descending ? aggs[k].reverse() : aggs[k]
            vm.indexes_[k].items = items
          }
        }
        if(vm.ikey !== null) {
          const on_ikey = vm.focus_on_key(vm.idx, vm.ikey)
          if(vm.imetano !== null) {
            on_ikey.then(()=>{
              debug('on_ikey', vm.imetano)
              vm.selected_arti = vm.imetano
              if(vm.dic_mode) {
                // TODO 當圖文模式時應支援 goTo
                const id_ = `#masonry_${vm.imetano}`
                vm.$vuetify.goTo(id_)
              }
            })
          }
        }
      }
      const vm = this
      if(this.preloaded_artis && this.preloaded_artis.uniname == uniname) {
        load_indexed_artis(this.preloaded_artis)
        this.loading_indexes = false
      }
      else {
        const p2 = get_indexed_artis(uniname, opt).then(load_indexed_artis)
        .finally(() => {
          this.loading_indexes = false
        })
        wait_all.push(p2)
      }
      const p1 = get_journal(uniname).then((resp) => {
        this.jj = resp
      })

      wait_all.push(p1)
      if(this.cover_support_) {
        this.loading_vols = true
        this.vols.items = []
        const p4 = get_journal_vols(uniname).then((resp) => {
          const vols = this.sort_descending ? resp.vols : resp.vols.reverse()
          this.vols.items = vols
        }).finally(() => {
          this.loading_vols = false
        })
        wait_all.push(p4)
      }
      else {
        this.vols.items = []
      }
      return Promise.all(wait_all)
    }
  },
  watch: {
    cover_support_(v) {
      if(v) {
        this.loading_vols = true
        this.vols.items = []
        const p4 = get_journal_vols(this.uniname).then((resp) => {
          const vols = this.sort_descending ? resp.vols : resp.vols.reverse()
          this.vols.items = vols
        }).finally(() => {
          this.loading_vols = false
        })
      }
      else {
        this.vols.items = []
      }
    },
    ikey (ikey) {
      if(ikey != null) {
        const that = this
        that.focus_on_key(this.idx, ikey).then(()=>{
          this.$vuetify.goTo(0, {duration: 0})
        })
      }
    },
    idx(idx) {
      if(idx=='home') {
        this.filtered_artis = []
        this.filtered_desc = undefined
        this.filtered_artis_display_max = 200
      }
      if(this.filtered_artis.length == 0 && !this.show_sidebar) {
        this.show_sidebar = true
      }
    },
    uniname: {
      handler(uniname) {
        this.on_uniname(uniname)
        this.$store.commit('set_uniname', this.uniname)
        this.mainset_id = this.$store.state.mainset_id
        this.mainset_name = this.$store.state.mainset_name
        this.journal_name = this.$store.state.journal_name
      },
      immediate: true,
    },
  },
  created() {
    this.$store.subscribe((mutation)=>{
      if(mutation.type == 'toggle_context_sidebar') {
        this.show_sidebar = !this.show_sidebar
      }
      else if(mutation.type == 'setWindowHeight') {
        // debug('on setWindowHeight', mutation.payload)
      }
    })
  },
  updated() {
    if(this.fixresp_p == this.fixresp) {
      this.$redrawVueMasonry()
    }
    this.fixresp_p = this.fixresp
  },
  data() {
    // this.cached_filtered_artis = {}
    debug('data...')
    return {
      mainset_id: undefined,
      mainset_name: undefined,
      journal_name: undefined,

      fixresp: 1,
      fixresp_p: 1,
      index_vscroll_height: 800,
      artis_vscroll_height: 800-60,
      show_sidebar: true,
      q: "",

      filters: [],
      raw_artis: [],
      filtered_artis: [],
      filtered_artis_display_max: 200,
      filtered_desc: undefined,
      selected_arti: undefined,
      // artis_subtitle: null,
      loading_indexes: false,
      loading_filter: false,

      loading_vols: false,
      vols_per_line: 4,
      vol_selected: null,
      vols: {
        items: [],
        sort_descending: true,
        show_level: 2,  // 0: none, 1: less, 2: all
        show_levels: {2:1, 1:2},
      },

      indexes_: {
        all: {
          key: 'all',
          name: '所有',
          items: [{doc_count: 0, key: '所有'}],
          show_level: 2,  // 0: none, 1: less, 2: all
          show_levels: false,
          sort_descending: undefined,
        },
        word: {
          key: 'word',
          name: '單字',
          items: [],
          show_level: 2,
          show_levels: {2:1, 1:2},
          sort_descending: true,
          support_filter: true,
          filter_str: null,
        },
        branch: {
          key: 'branch',
          name: '分部',
          items: [],
          show_level: 2,  // 0: none, 1: less, 2: all
          // show_levels: {2:1, 1:0, 0:2},
          // show_levels: {2:1, 1:2},
          show_levels: false,
          sort_descending: true,
        },
        pubyear: {
          key: 'pubyear',
          name: '年份',
          items: [],
          show_level: 2,  // 0: none, 1: less, 2: all
          // show_levels: {2:1, 1:0, 0:2},
          // show_levels: {2:1, 1:2},
          show_levels: false,
          sort_descending: true,
        },
        pubtime: {
          key: 'pubtime',
          name: this.$t('pubtime'),
          items: [],
          show_level: 2,
          // show_levels: {2:1, 1:2},
          show_levels: false,
          sort_descending: true,
        },
        volno: {
          key: 'volno',
          name: '期別',
          items: [],
          show_level: 2,
          // show_levels: {2:1, 1:2},
          show_levels: false,
          sort_descending: true,
        },
        authors: {
          key: 'authors',
          name: '作者',
          items: [],
          show_level: 2,
          show_levels: {2:1, 1:2},
          sort_descending: true,
          support_filter: true,
          filter_str: null,
        },
        dynasty: {
          key: 'dynasty',
          name: '朝代',
          items: [],
          show_level: 2,
          show_levels: {2:1, 1:2},
          sort_descending: true,
          support_filter: true,
          filter_str: null,
        },
        title: {
          key: 'title',
          name: '詞條',
          items: [],
          show_level: 2,
          show_levels: {2:1, 1:2},
          sort_descending: true,
          support_filter: true,
          filter_str: null,
        },
        sourcesdes: {
          key: 'sourcesdes',
          name: '出處',
          items: [],
          show_level: 2,
          show_levels: {2:1, 1:2},
          sort_descending: true,
          support_filter: true,
          filter_str: null,
        },
      },
    };
  },
};
</script>
